import {
  IAddUpdateNewsfeedPageResponse,
  ICreateNewsfeedPayload,
  IFetchNewsfeedListResponse,
} from "interfaces/Index";

export const normalizeFetchNewsfeedListResponse = (
  res: Array<IFetchNewsfeedListResponse>,
  pagination: number | boolean,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  payload.newsfeedListsData = res.map(
    (newsfeedList: IFetchNewsfeedListResponse) => {
      return {
        id: newsfeedList.id ? newsfeedList.id : "",
        title: newsfeedList.title ? newsfeedList.title : "",
        description: newsfeedList.description ? newsfeedList.description : "",
        enabled: newsfeedList.enabled ? "ACTIVE" : "INACTIVE",
        content: newsfeedList.content ? newsfeedList.content : [],
        cta: newsfeedList.cta ? newsfeedList.cta : [],
      };
    }
  );
  return payload;
};

export const normalizeCreateNewsfeedPayload = (
  req: IAddUpdateNewsfeedPageResponse
) => {
  const payload: ICreateNewsfeedPayload = {
    id: req.id,
    title: req.title,
    description: "",
    enabled: req.status,
    content: [
      {
        url: req.contentUrl,
        type: (req.contentType as any).value,
      },
    ],
    cta:
      req.ctaName && req.ctaAction
        ? [
            {
              name: req.ctaName,
              action: req.ctaAction,
            },
          ]
        : [],
  };
  return payload;
};

export const normalizeUpdateNewsfeedPayload = (
  req: IAddUpdateNewsfeedPageResponse
) => {
  const payload: ICreateNewsfeedPayload = {
    id: req.id,
    title: req.title,
    description: "",
    enabled: req.status,
    content: [
      {
        id: req.contentId,
        url: req.contentUrl,
        type: (req.contentType as any).value,
      },
    ],
    cta:
      req.ctaName && req.ctaAction
        ? [
            {
              id: req.ctaId,
              name: req.ctaName,
              action: req.ctaAction,
            },
          ]
        : [],
  };
  return payload;
};
